/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgOptionGroup = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    viewBox="0 0 24 25"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.625 3.125H3.375a.75.75 0 0 0-.75.75v17.25c0 .415.335.75.75.75h17.25a.75.75 0 0 0 .75-.75V3.875a.75.75 0 0 0-.75-.75ZM7.906 16.813a.937.937 0 1 1 0-1.875.937.937 0 0 1 0 1.874Zm0-3.375a.937.937 0 1 1 0-1.875.937.937 0 0 1 0 1.874Zm0-3.376a.937.937 0 1 1 0-1.874.937.937 0 0 1 0 1.874Zm9.125 6.376a.188.188 0 0 1-.187.187H10.53a.188.188 0 0 1-.187-.188v-1.125c0-.103.084-.187.187-.187h6.313c.103 0 .187.084.187.188v1.124Zm0-3.375a.188.188 0 0 1-.187.187H10.53a.188.188 0 0 1-.187-.188v-1.124c0-.104.084-.188.187-.188h6.313c.103 0 .187.084.187.188v1.124Zm0-3.376a.188.188 0 0 1-.187.188H10.53a.188.188 0 0 1-.187-.188V8.563c0-.104.084-.188.187-.188h6.313c.103 0 .187.084.187.188v1.124Z"
    />
  </svg>
)
const Memo = memo(SvgOptionGroup)
export default Memo
